/* eslint-disable no-unused-vars */
import getLocalizedUrl from 'utils/getLocalizedUrl';

export const getNewSlugURL = (slugs, locale) => {
  let newPath = '';
  let isNewPath = false;
  slugs.forEach((slug) => {
    if (slug.new_slug) {
      newPath += `/${encodeURIComponent(slug.new_slug)}`;
      isNewPath = true;
    } else {
      newPath += `/${encodeURIComponent(slug.slug)}`;
    }
  });
  if (isNewPath) {
    if (locale) {
      return getLocalizedUrl(newPath, locale);
    }
    return newPath;
  }
  return null;
};
